import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { TStencilStore } from '../../../types/Stencil';
import { setShareWithOthers } from '../../../actions/stencils/editor';

function Sharing() {
  const allowSharing = useSelector(
    (state: TStencilStore) => state.settings.allowSharing
  );
  const shareWithOthers = useSelector(
    (state: TStencilStore) => state.submission.shareWithOthers
  );
  const dispatch = useDispatch();

  const setValue = useCallback(
    (newValue) => {
      dispatch(setShareWithOthers(newValue));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!allowSharing) {
      setValue(false);
    }
  }, [allowSharing, setValue]);

  return (
    <div className="c-form-group">
      <label className="c-form-label">Sharing</label>
      <label className="c-form-helper">
        The organizer is asking contributors to share their submitted content
        with other people who have been invited. This is optional. Would you
        like to share?
      </label>
      <div className="c-form-radio-group">
        <input
          type="radio"
          className="c-form-radio"
          name="stencil[share_with_others]"
          value="yes"
          defaultChecked={shareWithOthers}
          onChange={(e) => setValue(e.target.checked)}
          id="share_with_others_yes"
        />
        <label className="c-form-radio-label" htmlFor="share_with_others_yes">
          Yes, allow others invited to this project to see my contribution
        </label>
      </div>
      <div className="c-form-radio-group">
        <input
          type="radio"
          className="c-form-radio"
          name="stencil[share_with_others]"
          value="no"
          defaultChecked={!shareWithOthers}
          onChange={(e) => setValue(!e.target.checked)}
          id="share_with_others_no"
        />
        <label className="c-form-radio-label" htmlFor="share_with_others_no">
          No, do not allow others invited to this project to see my contribution
        </label>
      </div>
    </div>
  );
}

export default Sharing;
